import {
  Avatar,
  Box,
  Flex,
  HStack,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  Image,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { BsBellFill } from "react-icons/bs";
import { MdKeyboardArrowDown } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import { IUser } from "../../models/auth.model";
import {
  destroyUserSession,
  getLocalUserProfile,
} from "../../services/auth.service";
import UserNotificationsModal from "../common/UserNotifications";
import naptinlogo from "../../img/naptinlogo.png";
const AdminDashboardHeader = () => {
  const [userProfile, setUserProfile] = useState<IUser | null>();
  const [isOpen, setIsOpen] = useState(false);

  const router = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const user = getLocalUserProfile();
    setUserProfile(user);
  }, []);

  const handleLogout = () => {
    destroyUserSession();
    router("/");
  };

  return (
    <Box width={"100%"}>
      <Box px={["2px", "2px", "4px", "12px"]}>
        <Flex
          height="45px"
          bg="#FFFFFF"
          color="#616161"
          direction="row"
          //   mt="10px"
          alignItems="center"
          justifyContent={["space-between", "space-between", "space-between", "flex-end"]}
        >
          <Flex
            ml="5px"
            alignContent="center"
            display={["flex", "flex", "flex","none"]}
          >
            <Box as="span">
              <Image src={naptinlogo} height="45px" />
            </Box>
          </Flex>

          <HStack spacing={["2px", "2px", "4px", "6px"]} justifyContent={"space-around"}>
            <IconButton
              variant="ghost"
              aria-label="bell"
              color="brand.2"
              borderRadius={20}
              onClick={() => setIsOpen(true)}
              icon={<BsBellFill />}
            />

            <Avatar size="sm" name={userProfile?.name} />
            <Menu>
              <MenuButton>
                <HStack color="brand.subtitle" fontSize={13}>
                  <Flex direction="column" alignItems="flex-end">
                    <Text whiteSpace="nowrap"> {userProfile?.name} </Text>
                  </Flex>
                  <MdKeyboardArrowDown />
                </HStack>
              </MenuButton>
              <MenuList fontSize={13} borderRadius={0} color="brand.bodyText">
                <MenuItem onClick={() => handleLogout()}>Logout</MenuItem>
              </MenuList>
            </Menu>
          </HStack>
        </Flex>
      </Box>
      {isOpen && <UserNotificationsModal setIsOpen={setIsOpen} />}
    </Box>
  );
};

export default AdminDashboardHeader;
